import 'moment/locale/de';
import * as React from 'react';
import { Redirect, Route, Switch } from "react-router";
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import DebugComponent from './components/debug/debug_component';
import BusfahrerComponent from './components/stadtbus/busfahrer_component';
import FahrgastComponent from './components/stadtbus/fahrgast_component';
import HaltestelleComponent from './components/stadtbus/haltestelle_component';
import StopMap from './components/stadtbus/stop_map/stop_map';
import withTracker from './with_tracker';

class App extends React.Component {
  constructor(props: any) {
    super(props);
  }

  public render() {
    return <Router>
      <Switch>
        <Route path={`${process.env.PUBLIC_URL}/stadtbus/karte-full/:lat?/:lng?/:zoom?`} render={(props) => <StopMap fullscreen={true} {...props}/>}/>
        <Route path={`${process.env.PUBLIC_URL}/stadtbus`} component={withTracker(FahrgastComponent)}/>
        <Route path={`${process.env.PUBLIC_URL}/busfahrer`} component={withTracker(BusfahrerComponent)}/>
        <Route path={`${process.env.PUBLIC_URL}/haltestelle/:id`} component={withTracker(HaltestelleComponent)}/>
        <Route path={`${process.env.PUBLIC_URL}/debug`} component={withTracker(DebugComponent)}/>
        <Route path={`${process.env.PUBLIC_URL}/stadtbus-images`}/>
        <Redirect to={`${process.env.PUBLIC_URL}/stadtbus`} />
      </Switch>
    </Router>;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx